import { ConvertHelper, TypeHelper } from "../../../../../../../../helpers"

import { NotificationType } from "../../../../../../../../models/util/email-notification-options"
import { OpOperator } from "../../../../../../../../models/core"

type NotificationState = {
    sms: {
        option: number,
        recipientsIds: number[],
    },

    email: {
        option: number,
        recipientsIds: number[],
    }
}

export class OperatorDetailsNotificationsPageState {

    //#region Members

    private notificationType: NotificationType
    private originalHash: string
    private originalOperator: OpOperator
    private operatorToEdit: OpOperator
    private state: NotificationState

    //#endregion


    //#region Properties

    public get operator(): OpOperator {
        return this.operatorToEdit
    }

    //#endregion


    //#region State

    public hasChanges(): boolean {
        return this.originalHash !== ConvertHelper.hash(this.state)
    }

    public setOperator(operator: OpOperator) {
        this.originalOperator = operator
    }

    public updateStateOptions(operator: OpOperator): void {
        switch (this.notificationType) {
            case NotificationType.Issue:
                this.state.email.option = operator.emailNotificationOptions.getIssueOptions()
                this.state.sms.option = operator.smsNotificationOptions.getIssueOptions()
                this.state.email.recipientsIds = operator.emailNotificationOptions.getIssueIdDistributorOptions()
                this.state.sms.recipientsIds = operator.smsNotificationOptions.getIssueIdDistributorOptions()

                break;

            case NotificationType.Task:
                this.state.email.option = operator.emailNotificationOptions.getTaskOptions()
                this.state.sms.option = operator.smsNotificationOptions.getTaskOptions()
                this.state.email.recipientsIds = operator.emailNotificationOptions.getTaskIdDistributorOptions()
                this.state.sms.recipientsIds = operator.smsNotificationOptions.getTaskIdDistributorOptions()

                break;

            case NotificationType.WorkOrder:
                this.state.email.option = operator.emailNotificationOptions.getWorkOrderOptions()
                this.state.sms.option = operator.smsNotificationOptions.getWorkOrderOptions()

                break

            case NotificationType.Location:
                this.state.email.option = operator.emailNotificationOptions.getLocationOptions()
                this.state.sms.option = operator.smsNotificationOptions.getLocationOptions()
                this.state.email.recipientsIds = operator.emailNotificationOptions.getLocationIdDistributorOptions()
                this.state.sms.recipientsIds = operator.smsNotificationOptions.getLocationIdDistributorOptions()

                break;
        }
    }

    public updateStateRecipients(recipientIds: number[]): void {
        switch (this.notificationType) {
            case NotificationType.Issue:
                this.state.email.recipientsIds = TypeHelper.clone(recipientIds)
                this.state.sms.recipientsIds = TypeHelper.clone(recipientIds)

                break;

            case NotificationType.Task:
                this.state.email.recipientsIds = TypeHelper.clone(recipientIds)
                this.state.sms.recipientsIds = TypeHelper.clone(recipientIds)

                break;

            case NotificationType.WorkOrder:
                this.state.email.recipientsIds = TypeHelper.clone(recipientIds)
                this.state.sms.recipientsIds = TypeHelper.clone(recipientIds)

                break

            case NotificationType.Location:
                this.state.email.recipientsIds = TypeHelper.clone(recipientIds)
                this.state.sms.recipientsIds = TypeHelper.clone(recipientIds)

                break;
        }
    }

    public reset(): void {
        this.state = {
            email: {
                option: 0,
                recipientsIds: []
            },

            sms: {
                option: 0,
                recipientsIds: []
            }
        }

        this.updateStateOptions(this.originalOperator)
        this.originalHash = ConvertHelper.hash(this.state)
        this.operatorToEdit = this.prepareOperator(this.originalOperator)
    }

    private prepareOperator(sourceOperator: OpOperator): OpOperator {
        const operator: OpOperator = sourceOperator.clone(true, true, true, true)

        operator.emailNotificationOptions = sourceOperator.emailNotificationOptions.clone(true, true, true, true)
        operator.smsNotificationOptions = sourceOperator.smsNotificationOptions.clone(true, true, true, true)

        operator.emailNotificationOptions.owner = operator
        operator.smsNotificationOptions.owner = operator

        return operator
    }

    //#endregion


    //#region Factory

    public static fromOperator(operator: OpOperator, notificationType: NotificationType): OperatorDetailsNotificationsPageState {
        const state: OperatorDetailsNotificationsPageState = new OperatorDetailsNotificationsPageState()

        state.notificationType = notificationType

        state.setOperator(operator)
        state.reset()

        return state
    }

    //#endregion
}